import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-19e249de")

_pushScopeId("data-v-19e249de")
const _hoisted_1 = { class: "InvoiceBasic" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "InvoiceBasic__title" }, "Основная информация", -1)
const _hoisted_3 = { class: "InvoiceBasic__row" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_invoice_basic_delivery = _resolveComponent("invoice-basic-delivery")!
  const _component_invoice_basic_delivery_history = _resolveComponent("invoice-basic-delivery-history")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_invoice_basic_delivery),
      (_ctx.invoiceState.data && _ctx.invoiceState.data.invoice_number)
        ? (_openBlock(), _createBlock(_component_invoice_basic_delivery_history, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ]))
})